export default __webpack_public_path__ + "static/media/Microsoft.377df105.PNG";